import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@src/components/Tooltip';
import { Box } from '@mui/material';
import { RestartAltRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { DEFAULT_CLIENT_PAUSE } from '@src/constants/tts';
import apis from '@src/apis';
import { StyledPunctuation } from './index.style';
import PunctuationList from './PunctuationList';

const Punctuation = ({ clientPause, setClientPause, ttsPreset }) => {
  const { t } = useTranslation();
  const fetchClientPause = async () => {
    if (ttsPreset) {
      setClientPause(ttsPreset?.clientPause);
      return;
    }
    const data = await apis.clientPause.getClientPause();
    if (data?.status) {
      const { clientPause: dataClientPause } = data.result || {};
      if (dataClientPause) {
        const secClientPause = Object.keys(DEFAULT_CLIENT_PAUSE).reduce(
          (acc, key) => {
            acc[key] = dataClientPause[key] ?? DEFAULT_CLIENT_PAUSE[key];
            return acc;
          },
          {},
        );
        setClientPause(secClientPause);
      }
    }
  };

  useEffect(() => {
    fetchClientPause();
  }, []);

  const handleChangeSeconds = (key, sec) =>
    setClientPause({
      ...clientPause,
      [key]: Number(Number(sec).toFixed(2)),
    });

  const onResetClientPause = () => {
    setClientPause(DEFAULT_CLIENT_PAUSE);
  };

  return (
    <StyledPunctuation>
      <Box className="punctuation-header">
        <Box className="punctuation-title">
          <Typography variant="body-14-semibold">
            {t('configClientPause')}
          </Typography>
          <Typography variant="body-12-regular" color={COLOR.label2[64]}>
            * {t('configClientPauseNote')}
          </Typography>
        </Box>
        <Tooltip arrow title={t('reset')} placement="top">
          <RestartAltRounded
            sx={{ color: COLOR.indigo.default, cursor: 'pointer' }}
            onClick={onResetClientPause}
          />
        </Tooltip>
      </Box>
      <PunctuationList
        clientPause={clientPause}
        handleChangeSeconds={handleChangeSeconds}
      />
    </StyledPunctuation>
  );
};

export default Punctuation;
